var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"price-change-stamp pf-icon bx",class:_vm.classes}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }